export default {
  data() {
    return {
      loading: false,
      _loadingCount: 0,
      _loadingTimer: null
    }
  },
  beforeDestroy() {
    if (this._loadingTimer) {
      clearTimeout(this._loadingTimer)
      this._loadingTimer = null
    }
  },
  methods: {
    loadingStart(timeout = 20000) {
      this._loadingCount++
      // this.loading = true
      if (this._loadingTimer) {
        clearTimeout(this._loadingTimer)
        this._loadingTimer = null
      }
      this._loadingTimer = setTimeout(() => {
        this._loadingCount = 0
        this.loading = false
      }, timeout)
    },
    loadingEnd() {
      this._loadingCount = Math.max(0, this._loadingCount - 1)
      if (!this._loadingCount) {
        this.loading = false
        if (this._loadingTimer) {
          clearTimeout(this._loadingTimer)
          this._loadingTimer = null
        }
      }
    }
  }
}
